import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import CampaignFeatureFlow from "./campaignFeatureFlow";
import { CampaignFeaturesMap } from "./campaignConfig";
import CampaignHeader from "./campaignHeader";
import CampaignJobs from "./campaignJobs";
import { CampaignFeatureConfig } from "../../interfaces/campaignConfig";
import CampaignMode from "../../interfaces/campaignModes";
import ManageTemplates from "./manageTemplates";
 
const Campaign: React.FC = () => {
    const [campaignMode, setCampaignMode] = useState<CampaignMode>(CampaignMode.RUN);
    const [campaignType, setCampaignType] = useState<string>('');
    const [selectedCampaignConfig, setSelectedCampaignConfig] = useState<CampaignFeatureConfig | undefined>(undefined);
    const [leftMargin, setLeftMargin] = useState<string>("16px");

    useEffect(() => {
        setSelectedCampaignConfig(CampaignFeaturesMap[campaignType]);
    }, [campaignType]);

    const resetComponent = () => {
        setLeftMargin("16px");
        setCampaignType('');
    };

    useEffect(() => {
        resetComponent(); // reset the component when campaign mode changes.
    }, [campaignMode]);

    return (
        <Box sx={{ ml: leftMargin, mr: 2 }}>
            <CampaignHeader
                campaignMode={campaignMode}
                setCampaignMode={setCampaignMode}
                campaignType={campaignType}
                setCampaignType={setCampaignType}
            />
            {!campaignType ? (
                <Box display="flex" justifyContent="center" alignItems="center" py={4} sx={{ ml: 2, mr: 2 }}>
                    <Typography variant="h6" color="text.secondary">
                        Please select a campaign type
                    </Typography>
                </Box>
            ) : (
                <>
                    {campaignMode === CampaignMode.RUN && selectedCampaignConfig && (
                        <Box sx={{ ml: 2, mr: 2 }}>
                            <CampaignFeatureFlow
                                key={selectedCampaignConfig?.key}
                                feature={selectedCampaignConfig}
                            />
                        </Box>
                    )}
                    {campaignMode === CampaignMode.RESULTS && (
                        <CampaignJobs
                            campaignType={campaignType}
                            setLeftMargin={setLeftMargin}
                            setCampaignType={setCampaignType}
                        />
                    )}
                    {campaignMode === CampaignMode.TEMPLATES && (
                        <ManageTemplates campaignType={campaignType} />
                    )}
                </>
            )}
        </Box>
    );
};

export default Campaign;